import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import AthleteUserConstants from '../AthleteUserConstants';
import NavLinks from '../../../meet/NavLinks';
import EntryNavLinks from '../../EntryNavLinks';
import MyAthleteEntryNavLinks from '../../../myAthleteEntry/MyAthleteEntryNavLinks';
import MyMeetsNavLinks from '../../../myMeets/MyMeetsNavLinks';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOrgUnitAthleteEntryInfoData from '../../../../state/orgUnitAthleteEntryInfo/UseOrgUnitAthleteEntryInfoData';
import useOrgUnitAthleteContactData from '../../../../state/orgUnitAthleteContact/UseOrgUnitAthleteContactData';
import useAthleteEntryContextData from '../../../../state/athleteEntryContextView/UseAthleteEntryContextData';
import useMyAthleteMeetEntriesFiltersData from '../../../../state/myAthleteMeetEntriesFilters/UseMyAthleteMeetEntriesFiltersData';
import useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData from '../../../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData';
import useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData from '../../../../state/omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntry/UseOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import Constants from '@usas/ui-web/utils/Constants';
import { contactsIsComplete } from '../../../../components/leftNavigationOmeAthleteEntry/LeftNavValidation';

const INITIAL_MODAL_STATE = {
  displayPopUp: false,
  modalTitle: 'Delete Entry Contact?',
  contactName: '',
  emailAddress: '',
  orgUnitAthleteContactId: Constants.DEFAULT_ID
};

const useAthleteUserContacts = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { omeMeetState } = useOmeMeetData();
  const { orgUnitAthleteEntryInfoState, getOrgUnitAthleteEntryInfo } = useOrgUnitAthleteEntryInfoData();
  const { orgUnitAthleteContactState, getOrgUnitAthleteContacts, deleteOrgUnitAthleteContact } = useOrgUnitAthleteContactData();
  const { omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, getOrgUnitAthleteEntryIndividualRosterEntryByOrgUnitAthleteEntryId } =
    useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData();
  const { omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState, getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentials } = useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData();
  const { athleteEntryContextState, setAthleteEntryContextState } = useAthleteEntryContextData();
  const [modalState, setModalState] = useState(INITIAL_MODAL_STATE);
  const [state, setState] = useState({ tryGet: false, submitButton: '', tryRedirect: false, error: '', contact: {} });
  const { searchMeetState, setSearchMeetState } = useSearchMeetData();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { myAthleteMeetEntriesFiltersState } = useMyAthleteMeetEntriesFiltersData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const [tryGetContactsState, setTryGetContactsState] = useState(false);

  const onNextButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: AthleteUserConstants.CONTINUE, tryRedirect: true, error: '' });
  };

  const onSaveAndExitButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: AthleteUserConstants.SAVE_AND_EXIT, tryRedirect: true, error: '' });
  };

  const onAddContact = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    setState({ ...state, submitButton: AthleteUserConstants.ADD, tryRedirect: true, error: '' });
  };

  const onEditContact = (e, contact) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    setState({ ...state, submitButton: AthleteUserConstants.EDIT, tryRedirect: true, error: '', contact });
  };

  const onDeleteContactClicked = (e, contact) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState({
      ...modalState,
      displayPopUp: true,
      contactName: (contact.firstName || contact.middleName || contact.lastName) ? `${contact.firstName || ''} ${contact.preferredName !== '' && contact.preferredName !== contact.firstName ? '"' + contact.preferredName + '"' : ''} ${contact.middleName || ''} ${contact.lastName || ''}` : '',
      emailAddress: contact.emailAddress || '',
      orgUnitAthleteContactId: contact.orgUnitAthleteContactId || Constants.DEFAULT_ID
    });
  };

  const onModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState(INITIAL_MODAL_STATE);
  };

  const onDeleteContact = (e, orgUnitAthleteContactId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    deleteOrgUnitAthleteContact(orgUnitAthleteContactId);
    onModalCanceled();
    setTryGetContactsState(true);
  }

  useEffect(() => {
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setAthleteEntryContextState({ ...athleteEntryContextState, showNav: true });
    if (location.state && location.state.tryGet === true) {
      getOrgUnitAthleteEntryInfo(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId);
      getOrgUnitAthleteEntryIndividualRosterEntryByOrgUnitAthleteEntryId(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData?.orgUnitAthleteEntryId, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.omeMeetOrgUnitEntryId);
      getOrgUnitNonAthleteEntryOrgUnitAthleteEntryCredentials(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (location.state && location.state?.tryGetContacts === true) {
      setTryGetContactsState(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (orgUnitAthleteEntryInfoState.isObjLoaded === true && orgUnitAthleteEntryInfoState.isObjLoading === false &&
      omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isObjLoading === false && orgUnitAthleteContactState.isArrayLoading === false &&
      orgUnitAthleteContactState.isSaving === false && (orgUnitAthleteContactState.isArrayLoaded === false || tryGetContactsState === true)) {
      getOrgUnitAthleteEntryInfo(omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.orgUnitAthleteEntryId);
      getOrgUnitAthleteContacts(orgUnitAthleteEntryInfoState.objData?.omeMeetId, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.objData?.personId);
      if (tryGetContactsState === true) {
        setTryGetContactsState(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUnitAthleteEntryInfoState, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, orgUnitAthleteContactState, tryGetContactsState])

  useEffect(() => {
    if (orgUnitAthleteEntryInfoState.isObjLoaded === true && orgUnitAthleteEntryInfoState.isObjLoading === false &&
      orgUnitAthleteContactState.isArrayLoading === false && orgUnitAthleteContactState.isSaving === false &&
      omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading === false &&
      omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isObjLoading === false &&
      omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading === false && state.tryRedirect === true) {
      if (state.submitButton === AthleteUserConstants.CONTINUE) {
        if (contactsIsComplete(orgUnitAthleteEntryInfoState.objData) === false) {
          setState({
            ...state, tryRedirect: false, submitButton: '', error: 'At least one Entry Contact is required.'
          });
        }
        else {
          if (omeMeetState.route !== '') {
            navigate(NavLinks.ATHLETE_ENTRIES);
          }
          else {
            navigate(EntryNavLinks.ATHLETE_ENTRIES);
          }
        }
      }
      else if (state.submitButton === AthleteUserConstants.SAVE_AND_EXIT) {
        if (omeMeetState.route === '') {
          if (selectOrgUnitState.orgUnitId === '') {
            //My Athlete Meet Entries Route
            navigate(MyAthleteEntryNavLinks.MY_ATHLETE_ENTRY, { state: { myAthleteMeetEntriesFiltersState: myAthleteMeetEntriesFiltersState } });
          }
          else {
            //OME Route
            navigate(MyMeetsNavLinks.MEET_ENTRY_ATHLETE, { state: { selectOrgUnitState: selectOrgUnitState } });
          }
        }
        else {
          //Meet Route
          setSearchMeetState({ ...searchMeetState, showMeetHeader: true });

          navigate(NavLinks.MEET_ENTRY_ATHLETE, { state: { goToMeet: true } });
        }
      }
      else if (state.submitButton === AthleteUserConstants.ADD) {
        if (omeMeetState.route !== '') {
          navigate(NavLinks.ATHLETE_CONTACTS_DETAIL);
        }
        else {
          navigate(EntryNavLinks.ATHLETE_CONTACTS_DETAIL);
        }
      }
      else if (state.submitButton === AthleteUserConstants.EDIT) {
        if (omeMeetState.route !== '') {
          navigate(NavLinks.ATHLETE_CONTACTS_DETAIL, {
            state: {
              orgUnitAthleteContactId: state.contact?.orgUnitAthleteContactId || '',
              memberId: state.contact?.memberId || '',
              personId: state.contact?.personId || '',
              emailAddress: state.contact?.emailAddress || ''
            }
          });
        }
        else {
          navigate(EntryNavLinks.ATHLETE_CONTACTS_DETAIL, {
            state: {
              orgUnitAthleteContactId: state.contact?.orgUnitAthleteContactId || '',
              memberId: state.contact?.memberId || '',
              personId: state.contact?.personId || '',
              emailAddress: state.contact?.emailAddress || ''
            }
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUnitAthleteEntryInfoState, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading,
    omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isObjLoading, omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading,
    state, orgUnitAthleteEntryInfoState.objData, orgUnitAthleteContactState]);

  return {
    state,
    athleteEntryContextState,
    orgUnitAthleteContactState,
    isLoading: orgUnitAthleteContactState.isArrayLoading || omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading ||
      omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isObjLoading ||
      omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState.isArrayLoading ||
      orgUnitAthleteEntryInfoState.isObjLoading,
    Constants,
    modalState,
    onNextButtonClicked,
    onSaveAndExitButtonClicked,
    onAddContact,
    onEditContact,
    onDeleteContactClicked,
    onDeleteContact,
    onModalCanceled
  };
}

export default useAthleteUserContacts;